<template>
  <div :class="[props.customTagClass ? `tag-item-${props.customTagClass}` : 'tag-item']">
    <slot v-if="props.textTag" />
    <NuxtLink v-if="props.linkTag" :to="{path:props.link, query: { searchWords : props.text, t:Date.now()}}">{{ props.text }}</NuxtLink>
    <button
      type="button"
      class="tag-delete-btn"
      @click.stop.prevent="handleSearchItemDelete"
    ></button>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps({
  link: String,
  text: String,
  customTagClass: String,
  linkTag: Boolean,
  textTag: Boolean,
  deleteType: String,
  value: Number
});

const { 
  showAlert 
} = usePopup()

// tag 아이템 클릭
const handleSearchItemDelete = () => {
  
  if(props.deleteType === 'recentSearchword') {
    if(props.value) {
      deleteRecentSearchword(props.value);
    }  
  }
  else {
    const searchItemButtons = document.querySelectorAll(".tag-delete-btn");
    searchItemButtons.forEach(function(button) {
      button.addEventListener("click", function () {
        const searchItem = button.closest(".tag-li") as HTMLElement;
        searchItem.remove();
      });
    });
  }
};

const fetchBuilder  = useHconFetchBuilder();

// 최근검색어 선택 삭제 API 호출
const deleteRecentSearchword = async (value: number) => {

  const fetchBuilderResult = 
  await fetchBuilder.delete<AjaxResult<number>>('/api/v1/product/display/recent-searchword-delete/' + value)
  .body({rcntScwdSeq: value})
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      const searchItemButtons = document.querySelectorAll(".tag-delete-btn");
      searchItemButtons.forEach(function(button) {
        button.addEventListener("click", function () {
          const searchItem = button.closest(".tag-li") as HTMLElement;
          searchItem.remove();
          
        });
      });
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}
</script>
<style lang="scss" scoped>
</style>
